import { Component, Inject, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Utility } from '../../../common/utility';
import { AppMessages } from '../../../shared/constants/messages';
import { AppConstants } from '../../../shared/constants/constants';
import { ManageUserPatientModel } from '../../../models/centre/manage-user-patient.model';
import { ManagePatientAccountService } from './manage-patient.service';
import { DialogService } from '../../../shared/services/dialog.service';
import { ModifyPatientPopupComponent } from './modify-patient-popup.component';
import { SharedService } from '../../../shared/services/share.services';
import { TMBDataTableComponent } from '../../../components/data-table/data-table.component';

@Component({
  selector: 'manage-patient',
  templateUrl: 'manage-patient-list.component.html',
  providers: [ManagePatientAccountService]
})

export class ManagePatientUserComponent extends TMBDataTableComponent implements OnInit {
  public appConstants = AppConstants;
  managePatientUserAccount: FormGroup;
  public filterData = { patientName: '' };
  dataRow = new Array<ManageUserPatientModel>();
  countries: any;

  constructor(
    public managePatientService: ManagePatientAccountService,
    public dialogService: DialogService,
    public sharedService: SharedService,
    public utility: Utility) {
      super(sharedService);
    }

  ngOnInit() {
    this.setPage({ offset: 0 });
  }

  setPage(pageInfo) {
    this.page.pageNumber = pageInfo.offset;
    const param = {
      pageSize: this.page.size,
      currentPage: this.page.pageNumber + 1,
      patientName: this.filterData.patientName
    };
    // call api
    // this.dataRow = this.managePatientService.getPatientList(param);
    this.managePatientService.getPatientList(param).subscribe(
      (result) => {
        if (result) {
          const data = result.json();
          // this.page.totalElements = data['totalCount'];
          // this.page.totalPages = Math.ceil(this.page.totalElements / this.page.size);
          this.dataRow = data; // ['list'];
        }
      }
    );
    this.managePatientService.getPatientCount(param).subscribe(
      (result) => {
        if (result) {
          const data = result.json();
          this.page.totalElements = data['total'];
          this.page.totalPages = Math.ceil(this.page.totalElements / this.page.size);
        }
      }
    );
  }

  onEditItem(id) {
    this.dialogService.openComponentDialog(ModifyPatientPopupComponent,
      { id: id, edit: true },
      { width: '80%' }).subscribe(result => {
        // if add user success then reload the list
        if (result) {
          this.reloadPage(this.page.pageNumber, this.dataRow);
        }
      });
  }

  onRemoveItem(id) {
    this.dialogService.openConfirmationDialog({ message: AppMessages.patient.removePatient }).subscribe(result => {
      if (result) {
        this.managePatientService.deletePatient(id).subscribe(
          (removeResult) => {
            if (removeResult) {
              this.setPage({ offset: 0 });
              const data = removeResult.json();
              this.dialogService.openSuccessDialog({ message: data.message });
            }
          }
        );
      }
    });
  }

  onAddPatientAccount(): void {
    this.dialogService.openComponentDialog(ModifyPatientPopupComponent,
      {},
      { width: '80%' }).subscribe(result => {
        // if add user success then reload the list
        if (result) {
          this.reloadPage(this.page.pageNumber, this.dataRow);
        }
      });
  }

  onFilter() {
    this.setPage({ offset: 0 });
  }

  getDataArray(dataArr: any[]) {
    let data = '';
    const seperate = ', ';
    for (let i = 0; i < dataArr.length; i++) {
      data += ((i !== 0) ? seperate : '') + dataArr[i];
    }
    return data;
  }

  getDataName(dataArr: any[]) {
    let data = '';
    const seperate = ' ';
    for (let i = 0; i < dataArr.length; i++) {
      data += ((i !== 0) ? seperate : '') + dataArr[i];
    }
    return data;
  }

  /**
   * Update user status
   * @param string userStatus
   * @param string userId
   */
  onStatusChange(patientData: any, event) {
    const checkedStatus = event.checked;
    const confirmMessage = (checkedStatus) ? AppMessages.centre.confirmDisablePatient : AppMessages.centre.confirmEnablePatient;
    this.dialogService.openConfirmationDialog({message: confirmMessage}).subscribe(result => {
      if (result) {
        const param = {
          id: patientData.id,
          status: checkedStatus.toString()
        };
        this.managePatientService.disablePatient(param).subscribe(
          resultApi => {
            if (resultApi) {

            }
          },
          error => {
               patientData.isDisable = !checkedStatus;
          }
        );
      } else {
        patientData.isDisable = !checkedStatus;
      }
    });
  }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/centre/manage-patient-user/manage-patient-list.component.ts